export function fixObject(params) {
  let new_params = params.substring(1);
  let category = JSON.parse(
    '{"' +
      decodeURI(new_params)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
  return category;
}
export default fixObject;
